module.exports = __webpack_public_path__ + "img/logo_inbi.fba6429c.png";